import { React, useRef, forwardRef, useImperativeHandle, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import moment from 'moment';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import TotalModalWrapper from '../../Share/Normal/TotalModalWrapper';

import { formatPhoneNumber } from '../../../Utils/phoneUtils';
import { useLanguage } from '../../../Context/LanguageContext';
import FetchModule from '../../Share/Network/FetchModule';

import { ReactComponent as ExitSvg } from '../../../image/ExitButtonImage.svg';
import { ReactComponent as DefaultLogoSvg } from '../../../image/DefaultLogo.svg';

import UserProfile from '../../../Component/Normal/UserProfile';
import CustomScrollbar from '../../Share/Normal/CustomScrollbar';

// import LockerMemberSearchInput from '../../../Component/LockerComponent/LockerMemberSearchInput';
// import LockerStartInput from '../../../Component/LockerComponent/LockerStartInput';
// import CalenderInput from '../../../Component/LockerComponent/LockerCalenderInput';

const LockerHistoryModal = forwardRef((props, ref) => {
  const { exitClick, saveClick, data } = props;
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t, isEng, languageMode } = useLanguage();

  const history = useHistory();

  const [lockerName, setLockerName] = useState('');
  const [dataList, setDataList] = useState([]);

  const MemberRef = useRef();
  const StartCalenderRef = useRef();
  const EndCalenderRef = useRef();
  const PriceRef = useRef();
  const CardRef = useRef();
  const CashRef = useRef();
  const bodyRef = useRef(null);

  useImperativeHandle(ref, () => ({
    getMemberData: () => {
      return MemberRef.current.getValue();
    },
    getStartDate: () => {
      return StartCalenderRef.current.getValue();
    },
    getEndDate: () => {
      return EndCalenderRef.current.getValue();
    },
    getPrice: () => {
      return PriceRef.current.getValue();
    },
    getCard: () => {
      return CardRef.current.getValue();
    },
    getCash: () => {
      return CashRef.current.getValue();
    },
  }));

  useEffect(() => {
    if (data === undefined) return;

    setLockerName(data.lockerName);

    let requestData = {
      lockerId: data.id
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('locker/usage/', 'POST', requestData);

        // console.log('락커 이용 내역 \n', responseData);

        if (responseData.status === 200) {
          setDataList(responseData.data);
        }
        else if (responseData.status === 401) {
          alert(t('main.locker.loginRequired'));
          history.push('/login');
        }
      }
    )();
  }, [data])

  function onClickSendMessageButton(index) {
    let text = dataList[index].userName + '님!, 지금까지 사용하셨던 락커에 물품이 남아있어요!\n빠르게 확인해보세요!! :)';

    let requestData = {
      userId: dataList[index].userId,
      data: text
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataOfCoach('push_notification/send', 'POST', requestData);

        if (responseData.status === 200) {
          alert(t('main.locker.history.pushSent'));
        }
        else if (responseData.status === 204) {
          alert(t('main.locker.history.withdrawn'));
        }
      }
    )();
  }

  // 전화번호 정리 //
  function calcPhoneView(data) {
    if (!data.phone || data.phone === '') return t('main.locker.history.noPhone');
    return formatPhoneNumber(data.phone, data.countryCode, languageMode) || t('main.locker.history.noPhone');
  }

  // 생년월일 정리 //
  function calcBirthView(data) {
    if (isEng) return moment(data.birth, 'YYYYMMDD').format(t('partnerGym.history.dateFormat'));
    return data.birth.slice(2, 4) + '.' + data.birth.slice(4, 6) + '.' + data.birth.slice(6, 8);
  }


  return (
    <TotalModalWrapper>
      <ModalView $isDark={isDark}>
        <TotalWrapper>
          <TopWrapper>
            <TitleWrapper>
              <Title>{t('main.locker.history.title').replace('{name}', lockerName)}</Title>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default' style={{height: '18px'} }>{t('main.locker.history.desc').replace('{locker}', lockerName)}</Text>
            </TitleWrapper>
            <ExitButton onClick={exitClick}>
              <ExitIcon />
            </ExitButton>
          </TopWrapper>
          <InfoWrapper>
            <ColumnWrapper>
              <ColumnText width={205} >{t('main.locker.history.tableHeaderMember')}</ColumnText>
              <ColumnText width={80} >{t('main.locker.history.tableHeaderStatus')}</ColumnText>
              <ColumnText width={150} >{t('main.locker.history.tableHeaderLastUsedDate')}</ColumnText>
            </ColumnWrapper>
            <DivisionLine />
            <ScrollAreaWrapper>
              <InfoBoxWrapper ref={bodyRef}>
              {
                dataList.map((data, index) => (
                  <InfoBox key={index}>
                    <Table>
                      <Body>
                        <Tr>
                          <Td style={{ marginRight: `5px` }}>
                            <ProfileWrapper>
                              {
                                (!data.profile || data.profile === '') ?
                                <DefaultLogoView />
                                :
                                <UserProfile profile={data.profile} defaultProfile='' />
                              }
                            </ProfileWrapper>
                          </Td>
                        </Tr>
                        <Tr>
                          <Td style={{ width: `148px` }}>
                            <NameInfoColumn>
                              <TextWrapper>
                                <Name>{data.userName}</Name>
                              </TextWrapper>
                              <TextWrapper>
                                <Phone>{calcPhoneView(data)}</Phone>
                              </TextWrapper>
                            </NameInfoColumn>
                          </Td>
                        </Tr>
                        <Tr>
                          <Td>
                            <TextWrapper style={{ width: `80px` }}>
                              <State State={data.state}>{data.state === '사용중' ? t('main.locker.history.using') : t('main.locker.history.ended')}</State>
                            </TextWrapper>
                          </Td>
                        </Tr>
                        <Tr>
                          <Td>
                            <TextWrapper style={{ width: `110px` }}>
                              <LastUsedDate>{(data.state === '사용중' || !data.lastUsedDate) ? '-' : moment(data.lastUsedDate).format(t('calendarInput.fullDateFormat3'))}</LastUsedDate>
                            </TextWrapper>
                          </Td>
                        </Tr>
                        <Tr>
                          <Td>
                            <TextWrapper>
                              {
                                data.state !== '사용중' &&
                                <SendButton>
                                  <SendButtonText onClick={() => onClickSendMessageButton(index)}>{t('main.locker.history.lostItem')}</SendButtonText>
                                </SendButton>
                              }
                            </TextWrapper>
                          </Td>
                        </Tr>
                      </Body>
                    </Table>
                  </InfoBox>
                ))
              }
              </InfoBoxWrapper>
              <CustomScrollbar
                direction='vertical'
                scrollRef={bodyRef}
                isColorScrollBar={true}
                thumbThickness={2}
                showTrackAlways={false}
                trackColor="transparent" />
            </ScrollAreaWrapper>
          </InfoWrapper>
        </TotalWrapper>
      </ModalView>
    </TotalModalWrapper >
  )
})

export default LockerHistoryModal;

const ModalView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  padding: 20px 20px 10px 20px;

  box-sizing: border-box;
  width: 603px;
  height: 510px;

  border-radius: 10px;
  // box-shadow: ${props => props.$isDark ? 'none' : '0px 40px 50px rgba(0, 0, 0, 0.1)'};
  background-color: ${props => props.theme.subBackground};
`;

const TotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 10px;
`;

const TopWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  width: 100%;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 5px;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;

  height: 30px;
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
`;

const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0 0 0 10px;

  box-sizing: border-box;
  width: 100%;
  height: 30px;

  gap: 5px;
`;

const ColumnText = styled.span`
  width: ${props => props.width}px;
  flex-shrink: 0;

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.text};

  text-align: flex-start;
`;

const ScrollAreaWrapper = styled.div`
  display: flex;
  flex-direction: row;

  width: 100%;
  height: 372px;
`;

const InfoBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  flex: 1;
  height: 100%;

  overflow-y: auto;
  overflow-x: hidden;

  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 10px;

  box-sizing: border-box;
  width: 100%;
  height: 62px;
`;

const Table = styled.table`
  display: flex;
  flex-direction: column;
`;

const Body = styled.tbody`
  display: flex;
  flex-direction: row;

  gap: 5px;
`;

const Tr = styled.tr`
  display: flex;
  flex-direction: row;
`;

const NameInfoColumn = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  width: 100%;
  min-width: 0;
`;

const Td = styled.td`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  overflow: hidden;

  width: 100%;
  min-width: 0;
  height: 21px;
`;

const Name = styled.span`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;

  transition: all 0.2s ease-in-out;
`;

const Phone = styled.span`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;

  transition: all 0.2s ease-in-out;
`;

const State = styled.span`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.State === '사용중' ? props.theme.subKey : props.theme.pointRed};

  transition: all 0.2s ease-in-out;
`;

const LastUsedDate = styled.span`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;

  transition: all 0.2s ease-in-out;
`;

const SendButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0px 9.5px;

  box-sizing: border-box;
  min-width: 125px;
  height: 21px;

  border-radius: 5px;
  background-color: ${props => props.theme.primary};

  &:hover {
    cursor: pointer;
  }
`;

const SendButtonText = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.subBackground};

  white-space: nowrap;

  margin: 0 0 0 0;
`;

const ExitButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: flex-start;

  width: 100%;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 24px;
  height: 24px;

  &:hover {
    cursor: pointer;
  }
`;

const ExitIcon = styled(ExitSvg)`
  width: 14px;
  height: 14px;

  flex-shrink: 0;

  & path {
    fill: ${props => props.theme.line};
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;

const ProfileWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 42px;
  height: 42px;

  border-radius: 3px;
  overflow: hidden;
  background-color: ${props => props.theme.buttonFill3};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const DefaultLogoView = styled(DefaultLogoSvg)`
  width: 65%;
  height: 65%;

  & path:nth-child(1) { fill: ${props => props.theme.logo1}; }
  & path:nth-child(2) { fill: ${props => props.theme.logo2}; }
  & path:nth-child(3) { fill: ${props => props.theme.logo1}; }
  & path:nth-child(4) { fill: ${props => props.theme.logo3}; }
`;

const DivisionLine = styled.div`
  margin: 7px 10px;

  box-sizing: border-box;
  width: calc(100% - 20px);
  height: 1px;

  background-color: ${props => props.theme.line};
`;
